import React, { useRef, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Grid } from '@mui/material';
import { Box } from '@mui/system';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import RadioInputs from 'src/components/inputs/RadioInputs';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useEffect } from 'react';
import SelectInputs from 'src/components/inputs/SelectInputs';

const indianStates = [
  { name: "Andhra Pradesh", code: "37" },
  { name: "Arunachal Pradesh", code: "12" },
  { name: "Assam", code: "18" },
  { name: "Bihar", code: "10" },
  { name: "Chhattisgarh", code: "22" },
  { name: "Goa", code: "30" },
  { name: "Gujarat", code: "24" },
  { name: "Haryana", code: "06" },
  { name: "Himachal Pradesh", code: "02" },
  { name: "Jharkhand", code: "20" },
  { name: "Karnataka", code: "29" },
  { name: "Kerala", code: "32" },
  { name: "Madhya Pradesh", code: "23" },
  { name: "Maharashtra", code: "27" },
  { name: "Manipur", code: "14" },
  { name: "Meghalaya", code: "17" },
  { name: "Mizoram", code: "15" },
  { name: "Nagaland", code: "13" },
  { name: "Odisha", code: "21" },
  { name: "Punjab", code: "03" },
  { name: "Rajasthan", code: "08" },
  { name: "Sikkim", code: "11" },
  { name: "Tamil Nadu", code: "33" },
  { name: "Telangana", code: "36" },
  { name: "Tripura", code: "16" },
  { name: "Uttar Pradesh", code: "09" },
  { name: "Uttarakhand", code: "05" },
  { name: "West Bengal", code: "19" },
  { name: "Delhi", code: "07" },
  { name: "Jammu & Kashmir", code: "01" },
  { name: "Ladakh", code: "38" },
  { name: "Chandigarh", code: "04" },
  { name: "Andaman & Nicobar Islands", code: "35" },
  { name: "Dadra & Nagar Haveli and Daman & Diu", code: "26" },
  { name: "Lakshadweep", code: "31" },
  { name: "Puducherry", code: "34" },
];

const initialValue = {
  address: '',
  clientName: '',
  clientNumber: '',
  clientEmail: '',
  gender: '',
  birthday: '',
  anniversary: '',
  clientGstNumber: '',
  clientPos: '',
  clientNote: '',
};

const initialFormValidation = {
  clientNameValidation: false,
  clientNumberValidation: false,
  clientGenderValidation: false,
};

const AddClient = () => {
const { createClient, updateClient, activeBranchId, setShowMessage, branchData, fetchClientByNumber, getBranch } = useMain();
  const [loading, setLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [formData, setFormData] = useState(initialValue);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [inputWidth, setInputWidth] = useState(0);
  const phoneInputRef = useRef(null);
  const [allClientsData, setAllClientsData] = useState([]);

  const clientNameValidation = !formData.clientName.trim();
  const clientNumberValidation = !formData.clientNumber || formData.clientNumber.length !== 10;
  const clientGenderValidation = !formData.gender;

    const clientNumberInputRef = useRef(null);
    const clientNameInputRef = useRef(null);
     useEffect(() => {
        // Small timeout to ensure the component is fully rendered
        const timer = setTimeout(() => {
          if (clientNumberInputRef.current) {
            clientNumberInputRef.current.focus();
          }
        }, 100);
    
        return () => clearTimeout(timer);
      }, []);

  const suggestionsRef = useRef(null);
  useEffect(() => {
    const fetchAllClients = async () => {
      try {
        const res = await getBranch(activeBranchId);
        setAllClientsData(res?.data?.client || []);
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    };
    if (activeBranchId) {
      fetchAllClients();
    }
  }, [activeBranchId]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'clientNumber') {
      setIsUpdating(false);
      setSelectedClientId(null);
    }
    setFormData({ ...formData, [name]: value });
  };
  // Digits only, removes +91 / 91 country code, max 10 digits
  const cleanPhone = (raw) => {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.length === 12 && digits.startsWith('91')) {
      digits = digits.slice(2);
    }
    return digits.slice(0, 10);
  };

  // Name, email, address, note: block leading spaces while typing
    const handleTextChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value.trimStart() }));
    };

    const handleNameChange = (e) => {
    setFormData((prev) => ({ ...prev, clientName: e.target.value.trimStart() }));
  };

  const handleNameBlur = (e) => {
    const trimmed = e.target.value.trim();
    setFormData((prev) => ({ ...prev, clientName: trimmed }));
  };

  const handleNamePaste = (e) => {
    e.preventDefault();
    const { selectionStart, selectionEnd, value } = e.target;
    const pasted = e.clipboardData.getData('text').trim();
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    setFormData((prev) => ({ ...prev, clientName: next }));
  };

  // Trim trailing spaces when the user leaves the field
  const handleTextBlur = (e) => {
    const { name, value } = e.target;
    const trimmed = value.trim();
    if (trimmed !== value) {
      setFormData((prev) => ({ ...prev, [name]: trimmed }));
    }
  };

  // Trim pasted text, then insert it at the cursor position
  const handleTextPaste = (e) => {
    e.preventDefault();
    const { name, selectionStart, selectionEnd, value } = e.target;
    const pasted = e.clipboardData.getData('text').trim();
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    setFormData((prev) => ({ ...prev, [name]: next }));
  };

  // Phone number: clean on typing and on paste
  const handlePhoneChange = (e) => {
    const cleaned = cleanPhone(e.target.value);
    setIsUpdating(false);
    setSelectedClientId(null);
    setFormData((prev) => ({ ...prev, clientNumber: cleaned }));
    handlePhoneNumberChange(cleaned);
  };

  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const handlePhoneNumberChange = (value) => {
  if (value.length > 0) {
    setShowSuggestions(true);
    const filtered = allClientsData.filter((client) =>
      client.clientNumber?.toLowerCase().includes(value.toLowerCase())
    );
    setSuggestions(filtered);
  } else {
    setSuggestions([]);
    setShowSuggestions(false);
  }
};


  const handleSuggestionClick = (suggestion) => {
    setFormData({
      ...formData,
      clientName: suggestion.clientName,
      clientNumber: suggestion.clientNumber,
      clientEmail: suggestion.clientEmail || '',
      gender: suggestion.gender || '',
      birthday: suggestion.birthday ? new Date(suggestion.birthday).toISOString().split('T')[0] : '',
      anniversary: suggestion.anniversary ? new Date(suggestion.anniversary).toISOString().split('T')[0] : '',
      address: suggestion.clientAddress?.address || '',
      clientGstNumber: suggestion.clientGstNumber || '',
      clientPos: suggestion.clientPos || '',
      clientNote: suggestion.clientNote || ''
    });
    setIsUpdating(true);
    setSelectedClientId(suggestion._id);
    setShowSuggestions(false);
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (suggestionsRef.current && !suggestionsRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSubmit = async () => {
    const { address, clientName, gender, clientNumber, clientEmail, anniversary, birthday, clientNote } =
      formData; // Destructure existing fields

    const validation = {
      clientNameValidation: !clientName.trim(),
      clientNumberValidation: !clientNumber || clientNumber.length !== 10,
      clientGenderValidation: !gender,
    };

    setFormValidation((pre) => ({ ...pre, ...validation }));

    if (Object.values(validation).some((item) => item)) return;

    try {
      setLoading(true);
      let res;
      if (isUpdating) {
        res = await updateClient(
          selectedClientId,
          {
            clientName,
            gender,
            clientEmail,
            clientNumber,
            clientAddress: {
              address,
            },
            anniversary,
            birthday,
            clientGstNumber: formData.clientGstNumber,
            clientPos: formData.clientPos,
            clientNote,
          },
  `?branchId=${activeBranchId}`,   
        );
      } else {
        res = await createClient(
          // Include new fields in the payload
          JSON.stringify({
            clientName,
            gender,
            clientEmail,
            clientNumber,
            clientAddress: {
              address,
            },
            anniversary,
            birthday,
            clientGstNumber: formData.clientGstNumber,
            clientPos: formData.clientPos,
            clientNote,
            branchDetails: activeBranchId,
          }),
        );
      }

      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || `Client successfully ${isUpdating ? 'updated' : 'created'}`,
          messageType: 'success',
        });
        setFormData(initialValue);
        setFormValidation(initialFormValidation);
        setIsUpdating(false);
        setSelectedClientId(null);
      } else {
        setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // This logic disables the mouse wheel event
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };

    window.addEventListener('wheel', handleWheel);
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <PageContainer title="Add Client" description="this is add Clients">
      <DashboardCard title="Add Client">
        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <div onBlur={handleNameBlur} onPaste={handleNamePaste}>
              <TextInputs
                title={'Client Name'}
                name={'clientName'}
                value={formData?.clientName}
                ref={clientNameInputRef}
                handleChange={handleNameChange}
                type={'text'}
                placeholder={'Client Name'}
                fieldValidation={clientNameValidation && formValidation.clientNameValidation}
              />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
            <div style={{ position: 'relative' }}>
              <TextInputs
                title={'Phone Number'}
                name={'clientNumber'}
                value={formData?.clientNumber}
                ref={clientNumberInputRef}
                handleChange={handlePhoneChange}
                type={'text'}
                placeholder={'87******22'}
                maxLength={10}
                fieldValidation={clientNumberValidation && formValidation.clientNumberValidation}
              />
              {showSuggestions && (
                <div
                  ref={suggestionsRef}
                  style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    width: '100%',   // now matches input width exactly
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    zIndex: 1,
                    maxHeight: '200px',
                    overflowY: 'auto',
                  }}
                >
                  {suggestionsLoading ? (
                    <div style={{ padding: '15px', textAlign: 'center' }}>Loading...</div>
                  ) : suggestions.length > 0 ? (
                    suggestions.map((suggestion) => (
                      <div
                        key={suggestion._id}
                        style={{
                          padding: '15px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #eee',
                        }}
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        {suggestion.clientName} - {suggestion.clientNumber}
                      </div>
                    ))
                  ) : (
                    <div style={{ padding: '10px', textAlign: 'center' }}>No suggestions found</div>
                  )}
                </div>
              )}
            </div>
          </Grid>
            <Grid item xs={12} md={4}>
              <RadioInputs
                title={'Gender'}
                name={'gender'}
                value={formData?.gender}
                handleChange={handleChange}
                options={[
                  { title: 'M', value: 'Male' },
                  { title: 'F', value: 'Female' },
                ]}
                fieldValidation={clientGenderValidation && formValidation.clientGenderValidation}
              />
            </Grid>
          </Grid>
        </Box>
        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextInputs
                required={false}
                title={'Email'}
                name={'clientEmail'}
                value={formData?.clientEmail}
                handleChange={handleTextChange}
                onBlur={handleTextBlur}
                onPaste={handleTextPaste}
                type={'email'}
                placeholder={'Email'}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextInputs
                required={false}
                title={'Address'}
                name={'address'}
                value={formData?.address}
                handleChange={handleTextChange}
                onBlur={handleTextBlur}
                onPaste={handleTextPaste}
                type={'text'}
                placeholder={'Address'}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextInputs
                title={'BirthDay'}
                required={false}
                name={'birthday'}
                value={formData?.birthday}
                handleChange={handleChange}
                type={'date'}
              />
            </Grid>
          </Grid>
        </Box>
        <Box style={{ marginTop: '20px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextInputs
                required={false}
                title={'Anniversary'}
                name={'anniversary'}
                value={formData?.anniversary}
                handleChange={handleChange}
                type={'date'}
              />
            </Grid>
            {branchData?.gstNumber && ( // Conditionally render if branchData.gstNumber is present
              <>
                <Grid item xs={12} md={4}>
                  <TextInputs
                    required={false}
                    title={'GST Number'}
                    name={'clientGstNumber'}
                    value={formData?.clientGstNumber}
                    handleChange={handleChange}
                    type={'text'}
                    placeholder={'Client GST Number'}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <SelectInputs
                    title={'Place of Supply'}
                    name={'clientPos'}
                    value={formData?.clientPos}
                    handleChange={handleChange}
                    options={indianStates.map(state => ({
                      value: `${state.name} (${state.code})`,
                      label: `${state.name} (${state.code})`
                    }))}
                    optionTitle="label"
                    optionValue="value"
                  />
                </Grid>
               
              </>
            )}
             <Grid item xs={12} md={12}>
              <TextInputs
                required={false}
                title={'Client Note'}
                name={'clientNote'}
                value={formData?.clientNote}
                handleChange={handleTextChange}
                onBlur={handleTextBlur}
                onPaste={handleTextPaste}
                type={'text'}
                placeholder={'Client Note'}
                multiline={true}
                rows={4}
              />
            </Grid>
          </Grid>
        </Box>
        <Box
          style={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* <div
                            style={{
                                width: '200px',
                                height: '38px',
                                borderRadius: '7px',
                                color: '#6174DD',
                                border: '0.5px solid #6174DD',
                                paddingLeft: '8px',
                                marginRight: '10px',
                            }}
                        >
                            <Button variant="text" color="primary" >
                                Filter
                            </Button>
                        </div> */}

            <div style={{ width: '200px' }}>
              {loading ? (
                <ShowLoader />
              ) : (
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={handleSubmit}
                >
                  {isUpdating ? 'Update Client' : 'Add Client'}
                </Button>
              )}
            </div>
          </div>
        </Box>
      </DashboardCard>
    </PageContainer>
  );
};

export default AddClient;
